import scheduleJobIcon from '@disy/cadenza-icons/report-subscription.svg';

import { Action } from 'cadenza/action';
import { isFeatureAvailable } from 'cadenza/features';
import { icon } from 'cadenza/utils/icon/icon';
import { cadenzaUrl } from 'cadenza/utils/cadenza-url/cadenza-url';
import { errorAlert } from 'cadenza/alert';
import { logger } from 'cadenza/utils/logging';
import type { FilterController } from 'cadenza/conditions/filter-controller';

import i18n from './schedule-job-action.properties';

export class ScheduleJobAction extends Action {

  constructor () {
    super({ label: i18n('title'), icon: icon(scheduleJobIcon) });
  }

  override get available () {
    return isFeatureAvailable('JOB_SUBSCRIPTION');
  }

  override get enabledSync () {
    return true;
  }

  override executeSync () {
    this._showJobScheduleWizard();
  }

  _showJobScheduleWizard () {
    const filterController = document.querySelector<FilterController>('.d-filter-controller');
    if (filterController && !filterController.validity.valid) {
      errorAlert(
        i18n('filter.invalid.warning.dialog.title'),
        i18n('filter.invalid.warning.dialog.message')
      ).catch(error => { logger.error('Failed to show warning dialog', error); });
    } else {
      location.href = cadenzaUrl('/pages/processingChain/report/schedule/index.xhtml' + location.search);
    }
  }

}
